import { useEffect } from 'react';
import './styles/App.css';
import AppProvider from './providers/app';
import AppRoutes from './routes';
import MaintenanceMode from './components/shared/maintenance-mode/MaintenanceMode';
import ReactGA from 'react-ga4';
import { initPostHog } from './utils/posthog';

ReactGA.initialize('G-RX7YZTR7JX');
initPostHog();

function App() {
  const maintenanceMode = false;

  // Disable right click on entire site EXCEPT for images
  useEffect(() => {
    const handleContextMenu = (event: MouseEvent) => {
      const target = event.target as HTMLElement;

      // Allow right-click ONLY on product images/links
      const isProductImage = target.closest('[data-product-image="true"]') !== null;
      const isProductLink = target.closest('[data-product-link="true"]') !== null;

      if (isProductImage || isProductLink) {
        return;
      }

      // Prevent right-click on general banners, background layouts, and text
      event.preventDefault();
    };

    document.addEventListener('contextmenu', handleContextMenu);
    return () => document.removeEventListener('contextmenu', handleContextMenu);
  }, []);

  return (
    <AppProvider>
      {maintenanceMode ? <MaintenanceMode /> : <AppRoutes />}
    </AppProvider>
  );
}

export default App;